export const isAuthenticatedSelector = (state) => state.auth.isAuthenticated;
export const isLoginAsSelector = (state) => state.auth.isLoginAs;
export const isAfterLogoutSelector = (state) => state.auth.afterLogout;
export const isUnauthorizedSelector = (state) => state.auth.isUnauthorized;
export const isUserBlockedSelector = (state) => state.auth.isUserBlocked;
export const isUserDeletedSelector = (state) => state.auth.isUserDeleted;
export const isUserGuestOnlySelector = (state) => state.auth.isUserGuestOnly;
export const unauthorizedUserSelector = (state) => state.auth.unauthorizedUser;
